import React, { useEffect } from 'react'
import styled from 'styled-components'
import db from '../../db';
import { onSnapshot, collection, query } from "firebase/firestore";
import Serviceimg from '../../Image/Services.png'
import Service1 from '../../Image/service1.png'
import Service2 from '../../Image/service2.png'
import Service3 from '../../Image/service3.png'
import Service4 from '../../Image/service4.png'

const Serviceinfo = () => {
  const [Servicedata, setServicesData] = React.useState([])


  useEffect(() => {
    const q = query(collection(db, "OurServices"))
    const unsub = onSnapshot(q, (querySnapshot) => {
      setServicesData(querySnapshot.docs.map(d => d.data()))
    });
    return () => unsub();
  }, []);

  // const Servicedata = [
  //   {
  //     serviceid: '1',
  //     serviceicon: Service1,
  //     servicename: 'Immediate Care',
  //     servicedes: 'Sed vel mollis mi. Pellentesque molestie ornare venenatis. Maecenas sagittis egestas erat non volutpat. Aliquam vel lectus nec quam gravida pharetra. Duis nec enim eu odio placerat mollis quis et arcu...',
  //     cliniconeloc: 'Brighton beach ave 23/2',
  //     cliniconesdays: 'Mon-Fri',
  //     cliniconetime: '11:00-20:00',
  //     clinictwoloc: 'Bay Ridge Ave, Brooklyn, NY 11220',
  //     clinictwosdays: 'Mon-Fri',
  //     clinictwotime: '11:00-20:00',
  //   },
  //   {
  //     serviceid: '2',
  //     serviceicon: Service2,
  //     servicename: 'Dental Care',
  //     servicedes: 'Curabitur lectus dolor, ullamcorper eu velit eu, sodales dictum elit. Ut dolor nisi, consequat sed luctus ut, aliquam sit amet nisi. Suspendisse nibh velit, iaculis sed nulla non, imperdiet euismod orci.',
  //     cliniconeloc: 'Brighton beach ave 23/2',
  //     cliniconesdays: 'Mon-Fri',
  //     cliniconetime: '11:00-20:00',
  //     clinictwoloc: 'Bay Ridge Ave, Brooklyn, NY 11220',
  //     clinictwosdays: 'Mon-Fri',
  //     clinictwotime: '11:00-20:00',
  //   },
  //   {
  //     serviceid: '3',
  //     serviceicon: Service3,
  //     servicename: 'Surgey Center',
  //     servicedes: 'Curabitur lectus dolor, ullamcorper eu velit eu, sodales dictum elit. Ut dolor nisi, consequat sed luctus ut, aliquam sit amet nisi. Suspendisse nibh velit, iaculis sed nulla non, imperdiet euismod orci.',
  //     cliniconeloc: 'Brighton beach ave 23/2',
  //     cliniconesdays: 'Mon-Fri',
  //     cliniconetime: '11:00-20:00',
  //     clinictwoloc: 'Bay Ridge Ave, Brooklyn, NY 11220',
  //     clinictwosdays: 'Mon-Fri',
  //     clinictwotime: '11:00-20:00',
  //   },
  //   {
  //     serviceid: '4',
  //     serviceicon: Service4,
  //     servicename: 'Diagnostic Center',
  //     servicedes: 'Curabitur lectus dolor, ullamcorper eu velit eu, sodales dictum elit. Ut dolor nisi, consequat sed luctus ut, aliquam sit amet nisi. Suspendisse nibh velit, iaculis sed nulla non, imperdiet euismod orci.',
  //     cliniconeloc: 'Brighton beach ave 23/2',
  //     cliniconesdays: 'Mon-Fri',
  //     cliniconetime: '11:00-20:00',
  //     clinictwoloc: 'Bay Ridge Ave, Brooklyn, NY 11220',
  //     clinictwosdays: 'Mon-Fri',
  //     clinictwotime: '11:00-20:00',
  //   },
  // ]


  return (
    <Serviceinformation>
      <ServiceImage src={Serviceimg} alt="Services Image" />
      <ServiceView>
        {Servicedata.map((service, index) => (
          <ServiceCard key={index}>
            <ServiceIcon src={Service1} alt={service.servicename} />
            <ServiceDetails>
              <ServiceName>{service.servicename}</ServiceName>
              <ServiceDescription>{service.servicedes}</ServiceDescription>
              <Availability>
                <AvailabilityHeading>Available Times</AvailabilityHeading>
                <AvailabilityInfo>
                  <ClinicLocation>{service.cliniclocation}</ClinicLocation>
                  {/* <ClinicLocation>{service.clinictwoloc}</ClinicLocation> */}
                  <ClinicDays>{service.clinicdays}</ClinicDays>
                  <ClinicTime>{service.clinictime}</ClinicTime>
                </AvailabilityInfo>
              </Availability>
            </ServiceDetails>
          </ServiceCard>
        ))}
      </ServiceView>
    </Serviceinformation>
  );
};

export default Serviceinfo;
const Serviceinformation = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const ServiceImage = styled.img`
  width: 100%;
  max-width: 100%;
  height: 50vh;
`;

const ServiceView = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin: 20px;
  padding: 0 10%;

  @media (min-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1450px) {
    padding: 0 20%;
  }
`;
const ServiceCard = styled.div`
  align-items: center;
  border-radius: 30px;
  padding: 20px;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
`;

const ServiceIcon = styled.img`
  width: 100%;
  height: 310px;`
  ;

const ServiceDetails = styled.div`
  text-align: left;
`;

const ServiceName = styled.div`
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  line-height: 27px;
  color: rgba(6, 33, 38, 1);
`;

const ServiceDescription = styled.div`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  color: rgba(6, 33, 38, 0.7);
`;

const Availability = styled.div`
  width: 100%;
  margin-top: 20px;
  border-radius: 30px 30px 0 0;
  color: white;
  `;

const AvailabilityHeading = styled.div`
  background: rgba(36, 190, 224, 1);
  border-radius: 30px 30px 0 0;
  max-height: 50px;
  padding: 15px 25px;
  `;
const AvailabilityInfo = styled.div`
  background: #ECF5FB;
  //   border-radius: 30px;
  color: black;
  padding: 15px 25px;
  border-radius: 0 0 30px 30px;
`;

const ClinicLocation = styled.div`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;

const ClinicDays = styled.div`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;

const ClinicTime = styled.div`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;